<template lang="pug">
v-container.justify-center.mt-md-4.mb-16.page-part
  .py-10.d-flex.justify-center(v-if="loading")
    v-progress-circular(size="50", color="primary", indeterminate)
  template(v-else)
    .text-h6.text-sm-h5.font-weight-bold.mb-3
      span.primary--text {{ part.title }} |
      span.ml-2.text--secondary {{ part.category.title }}
    grid-container(cols="auto", cols-md="max-content auto", gap="20px")
      product-gallery-widget(
        v-if="part.img.list",
        :items="part.img.list",
        :main="part.img.featured"
      )
      div
        .ck-content.mb-8(v-html="part.text")
        div
          v-btn.mt-3.py-6(
            :href="whatsappLink",
            target="_blank",
            color="primary",
            width="265px",
            tile,
            depressed
          )
            v-icon(left) fab fa-whatsapp
            span.font-weight-bold.poppins SOLICITAR ORÇAMENTO
</template>

<script>
import CustomTitle from "@/components/shell/CustomTitle.vue";
import ProductGalleryWidget from "@/components/widgets/ProductGallery.vue";
import { getWhatsappLinkFromPhone } from "@/components/utils.js";

const _config = {
  mod: "parts",
};

export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    branches() {
      return this.$rest("branches").list;
    },
    branch() {
      const getBranchByPartCategoryId = (partCategoryId) => {
        // { [x: partCategoryId]: branchId }
        const branchIdByPartCategoryId = {
          4: 1,
          5: 2
        }

        return this.branches.find(({ id }) => (branchIdByPartCategoryId[partCategoryId] === id));
      }

      return getBranchByPartCategoryId(this.part.category.id);
    },
    partId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
    part() {
      return this.$rest(_config.mod).item;
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    whatsappLink() {
      const whatsapp = this.branch && this.branch.whatsapp;

      if (!whatsapp) return;

      const link = getWhatsappLinkFromPhone(whatsapp);

      const { title } = this.part;

      let text = `Olá! Gostaria de um orçamento do *${title}:*.`;

      return `${link}?text=${encodeURIComponent(text)}`;
    },
  },
  methods: {
    formatDate(date) {
      return new Intl.DateTimeFormat("pt-BR", { dateStyle: "long" }).format(
        new Date(date)
      );
    },
    get() {
      this.loading = true;

      this.$rest(_config.mod)
        .get({ id: this.partId })
        .then(() => (this.loading = false))
        .catch(() => this.$router.replace("/error404"));
    },
  },
  watch: {
    partId() {
      this.get();
    },
  },
  created() {
    this.get();
  },
  components: {
    CustomTitle,
    ProductGalleryWidget,
  },
};
</script>
